import type { ComponentType } from 'react'
import { useEffect } from 'react'

import { useAuth } from '@enechain/auth-js'
import { LoadingEnechainLogo } from '@enechain/ecloud-designsystem'

import { clearGridCardLayouts } from '~/hooks/useGridCardLayout'

export const ProtectedAuthGuard = (Component: ComponentType): ComponentType => {
  const Wrapper = (): React.ReactElement => {
    const { isAuthenticated, isLoading, hasError, redirectToLogin, logout } =
      useAuth()

    useEffect(() => {
      const isSessionEnded = hasError || (!isLoading && !isAuthenticated)
      if (isSessionEnded) {
        // BottomMenu の明示ログアウトと同じく、**セッションが有効でないと
        // 判明した全経路**で、組織識別子を含む保存値を残さない
        // (`clearGridCardLayouts` の doc 参照)。強制ログアウト (`hasError`) と
        // 未認証 (セッション期限切れ・共用ブラウザでの再訪) を分けると、後者で
        // 前組織の BG コードが残ってしまうため、判定を 1 箇所に寄せる。
        clearGridCardLayouts()
      }
      if (hasError) {
        logout({ returnTo: window.location.href })
        return
      }
      if (!isLoading && !isAuthenticated) {
        redirectToLogin({ returnTo: window.location.href })
      }
    }, [isAuthenticated, isLoading, hasError, redirectToLogin, logout])

    if (isLoading || !isAuthenticated) {
      return <LoadingEnechainLogo />
    }

    return <Component />
  }
  Wrapper.displayName = `ProtectedAuthGuard(${Component.displayName ?? Component.name ?? 'Component'})`
  return Wrapper
}
